var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47610_26467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.43216 -0.0654297V12.0668H22.2794V-0.0654297H-1.43216Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.43216 -0.0654297L22.2794 12.0668L-1.43216 -0.0654297ZM22.2794 -0.0654297L-1.43216 12.0657L22.2794 -0.0654297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7496 13.1521L10.4237 7.35655L-0.902239 13.1521L-1.96198 10.9799L7.77218 5.99988L-1.96198 1.01988L-0.902239 -1.15234L10.4237 4.64321L21.7496 -1.15234L22.8094 1.01988L13.0752 5.99988L22.8094 10.9799L21.7496 13.1521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.43216 -0.0654297L22.2794 12.0668L-1.43216 -0.0654297ZM22.2794 -0.0654297L-1.43216 12.0657L22.2794 -0.0654297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9255 12.79L10.4236 6.90329L-1.07819 12.79L-1.78613 11.3422L8.65705 5.99996L-1.78613 0.657739L-1.07819 -0.790039L10.4236 5.09663L21.9255 -0.790039L22.6334 0.657739L12.1902 5.99996L22.6334 11.3422L21.9255 12.79Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4236 -0.0654297V12.0668V-0.0654297ZM-1.43216 6.00013H22.2794H-1.43216Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3998 12.0657H8.44749V8.02235H-1.43216V3.9779H8.44749V-0.0654297H12.3998V3.9779H22.2794V8.02235H12.3998V12.0657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4236 -0.0654297V12.0668V-0.0654297ZM-1.43216 6.00013H22.2794H-1.43216Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6093 12.0657H9.23795V7.21346H-1.43216V4.78679H9.23795V-0.0654297H11.6093V4.78679H22.2794V7.21346H11.6093V12.0657Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47610_26467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8473,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.9108db274303e2469d46b04bb61aed38.svg";
export { ForwardRef as ReactComponent };